// Shared colour tokens for the Document AI feature - previously duplicated as local consts in
// AiChatDialog.tsx, AiChatMinimizedBar.tsx and EnquiryFormDrawer.tsx (as ACCENT/AI_ACCENT, same
// value); pulled out once AiProcessingIndicator.tsx needed to match them too, rather than a
// fourth copy of the same hex. Explicit request: blue, not purple - and the same blue already
// used for the enquiry drawer's own header bar/selected-tab accent and info-avatar chip
// (EnquiryFormDrawer.tsx's own headerBar/infoAvatar), so the AI surfaces read as part of the
// same enquiry rather than a visually distinct bolt-on feature.
export const AI_ACCENT = '#1565c0';
export const AI_ACCENT_SOFT = '#e3f2fd';
